import { Spinner } from '@/components/Loader/Spinner';
import { MotiView, ThemeText, View } from '@/components/Theme';
import colors from '@/constants/Colors';
import { elements } from '@/constants/Styles';
import { iconSize } from '@/helper/Sizes';
import isEqual from 'lodash/isEqual';
import { memo, useMemo } from 'react';
import { StyleSheet } from 'react-native';

export const LoadingView = memo((props) => {
    
    const { 
        title = 'global.content_loading',
        titleProps = {}, 
        subline, 
        sublineProps = {},
        contentContainerStyle = null, 
        hideTitle = false, 
        spinnerSize = '2xl', 
        innerPadding = 12
    } = props;
    
    const _size = iconSize(spinnerSize);

    const spinnerDimensionOuter = useMemo(() => {
        return {
            width: _size + (innerPadding*2),
            height: _size + (innerPadding*2)
        }
    }, [_size, innerPadding]);

    const spinnerDimensionInner = useMemo(() => {
        return {
            width: _size + innerPadding,
            height: _size + innerPadding
        }
    }, [_size, innerPadding]);

    return (
        
        <View style={[styles.container, {width: '100%', height: '100%'}, contentContainerStyle]}>    
            <MotiView style={elements.center} from={{scale: .8, opacity: 0}} animate={{scale: 1, opacity: 1}}>
                <View style={[styles.spinnerWrapper, spinnerDimensionOuter]}>
                    <View style={[styles.spinnerWrapper, spinnerDimensionInner, {backgroundColor: colors.info[500]}]}>
                        <View w={_size} h={_size}>
                            <Spinner size={spinnerSize} color={'white'} />
                        </View>
                    </View>
                </View>
            
                {hideTitle != true && 
                    <>
                        <ThemeText mt={25} variant={'h1,center'} color={'info.500'} id={title} {...titleProps} />
                        {subline != null && <ThemeText mt={18} variant={'p,center'} id={subline} {...sublineProps} />}
                    </>
                }
            </MotiView>
        </View>
    );
}, isEqual);

const styles = StyleSheet.create({
    container: {
        ...elements.center,
        flexDirection: 'column',
        zIndex: 1000,
        paddingHorizontal: 25,
    },
    spinnerWrapper: {
        ...elements.center,
        backgroundColor: colors.info[500] + '50',
        borderRadius: 250,
        aspectRatio: 1,
    },
});